import React from 'react'

import KitCol1 from '../assets/images/award/premio_home-CO.png'
import KitCol2 from '../assets/images/award/premio_exlclusivo-CO.png'
import KitPe1 from '../assets/images/award/premio_home-PE.png'
import KitPe2 from '../assets/images/award/premio_exlclusivo-PE.png'
import kitNosotras from '../assets/images/award/kit-nosotras-CO.png'

import KitEc2 from '../assets/images/award/premio_exclusivo-EC.png'
import KitEc1 from '../assets/images/award/premio_home-EC.png'

import Interactive_PE_1 from '../assets/images/activities/interactive/PE-1.png'
import Interactive_PE_2 from '../assets/images/activities/interactive/PE-2.png'
import Interactive_PE_3 from '../assets/images/activities/interactive/PE-3.png'

import Interactive_CL_1 from '../assets/images/activities/interactive/CL-1.png'
import Interactive_CL_2 from '../assets/images/activities/interactive/CL-2.png'
import Interactive_CL_3 from '../assets/images/activities/interactive/CL-3.png'

import Interactive_DO_1 from '../assets/images/activities/interactive/DO-1.png'
import Interactive_DO_2 from '../assets/images/activities/interactive/DO-2.png'
import Interactive_DO_3 from '../assets/images/activities/interactive/DO-3.png'

import Interactive_EC_1 from '../assets/images/activities/interactive/EC-1.png'
import Interactive_EC_2 from '../assets/images/activities/interactive/EC-2.png'
import Interactive_EC_3 from '../assets/images/activities/interactive/EC-3.png'

export const ENV = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'DEV'
export const LOCALE = process.env.LOCALE

export const competitionId = {
  DEV: {
    'es-PE': {
      tasks: 220,
      infoCole: 221,
    },
    'es-CO': {
      tasks: 218,
      infoCole: 219,
    },
    'es-CL': {
      tasks: 259,
      infoCole: 260,
    },
    'es-DO': {
      tasks: 262,
      infoCole: 263,
    },
    'es-EC': {
      tasks: 264,
      infoCole: 265,
    },
  },
  PDN: {
    'es-PE': {
      tasks: 220,
      infoCole: 221,
    },
    'es-CO': {
      tasks: 218,
      infoCole: 219,
    },
    'es-CL': {
      tasks: 283,
      infoCole: 284,
    },
    'es-DO': {
      tasks: 288,
      infoCole: 289,
    },
    'es-EC': {
      tasks: 270,
      infoCole: 271,
    },
  },
}[ENV][LOCALE]

export const costActivity = 0

export const kitWin = {
  'es-PE': {
    kit: KitPe1,
    kitExclusive: KitPe2,
    kitHome: KitPe1,
  },
  'es-CO': {
    kit: KitCol1,
    kitExclusive: KitCol2,
    kitHome: kitNosotras,
  },
  'es-EC': {
    kit: KitEc1,
    kitExclusive: KitEc2,
    kitHome: kitNosotras,
  },
}

export const InteractiveActivity = {
  'es-PE': {
    item1: Interactive_PE_1,
    item2: Interactive_PE_2,
    item3: Interactive_PE_3,
  },
  'es-CO': {
    item1: Interactive_PE_1,
    item2: Interactive_PE_2,
    item3: Interactive_PE_3,
  },
  'es-CL': {
    item1: Interactive_CL_1,
    item2: Interactive_CL_2,
    item3: Interactive_CL_3,
  },
  'es-DO': {
    item1: Interactive_DO_1,
    item2: Interactive_DO_2,
    item3: Interactive_DO_3,
  },
  'es-EC': {
    item1: Interactive_EC_1,
    item2: Interactive_EC_2,
    item3: Interactive_EC_3,
  },
}

export const videosActivity = {
  'es-PE': {
    changes: 'https://www.youtube.com/watch?v=PsvvITbmCEk&ab_channel=Nosotras',
    menstruation:
      'https://www.youtube.com/watch?v=0TDcVKnullE&ab_channel=Nosotras',
    routine: 'https://www.youtube.com/watch?v=GRdySNrGG3o&ab_channel=Nosotras',
  },
  'es-CO': {
    changes: 'https://www.youtube.com/watch?v=PsvvITbmCEk&ab_channel=Nosotras',
    menstruation:
      'https://www.youtube.com/watch?v=0TDcVKnullE&ab_channel=Nosotras',
    routine: 'https://www.youtube.com/watch?v=GRdySNrGG3o&ab_channel=Nosotras',
  },
  'es-CL': {
    changes: 'https://www.youtube.com/watch?v=Pf8AmWfdVpA',
    menstruation: 'https://www.youtube.com/watch?v=c73Fzcf36f8',
    routine: 'https://www.youtube.com/watch?v=wPZP4hqEvqY',
  },
}

export const nameParent = () => {
  switch (LOCALE) {
    case 'es-EC':
      return 'representante'
    case 'es-PE':
      return 'tutor'
    case 'es-PR':
      return 'encargado'
    case 'es-AR':
    case 'es-UY':
    case 'es-PY':
      return 'tutor legal'
    case 'es-DO':
      return 'tutor'
    case 'es-BO':
      return 'tutor'
    case 'es-CL':
      return 'apoderado'
    default:
      return 'acudiente'
  }
}

export const ageAdult = () => {
  switch (LOCALE) {
    case 'es-CO':
      return 20
    case 'es-PE':
      return 18
    default:
      return 18
  }
}

export const terms = () => {
  switch (LOCALE) {
    case 'es-PE':
      return [
        <>
          Todas las participantes de esta actividad deben estar registradas en
          NosotrasOnline.com, estar en el colegio y tener entre 9 a 13 años. El
          Kit Nosotras solo se entregará en las ciudades en las que tenemos
          cobertura, si tu ciudad no está dentro del listado no podemos
          entregarlo.
        </>,
        <>
          Al aceptar los términos y condiciones de la actividad las usuarias
          aceptan el manejo de sus datos por parte de la marca Nosotras.
        </>,
        <>
          Ganarán las usuarias que resuelvan las actividades y además hayan
          ingresado datos verídicos, los mismos que serán validados al momento
          de la entrega.
        </>,
        <>
          Solo participarán por Kits Nosotras usuarias cuyas edades comprendan
          entre los 9 a 13 años de edad. Dicho rango de edad corresponde a los
          grados con los cuales la marca trabaja el Programa Colegios.
        </>,
        <>
          Todas las imágenes de los premios que están en el sitio, son
          referenciales.
        </>,
        <>
          En caso de que la usuaria no pueda recibir el premio, no tendrá
          derecho a ningún otro producto diferente ni a ningún tipo de
          indemnización o compensación.
        </>,
        <>
          Los premios no son acumulables con otras promociones o actividades, no
          son intercambiables por dinero ni son canjeables por ningún otro
          concepto o producto identificado con la marca Nosotras ® o de Grupo
          Familia S. A.
        </>,
        <>
          La marca Nosotras tiene el derecho de anular o descalificar cualquier
          material que considere que no cumple con las reglas de la actividad.
          Así mismo, procederá con el material que no tenga relación con la
          mecánica de la actividad, que considere no apto o que atente contra
          los valores de la marca.
        </>,
        <>
          Con el hecho de participar en la actividad, las usuarias aceptan y
          autorizan que su nombre y sus imágenes aparezcan en las publicaciones
          y demás material de divulgación con fines promocionales que los
          organizadores deseen hacer durante el concurso o una vez este
          finalice, sin que ello implique la obligación de remunerarlas o
          compensarlas.
        </>,
        <>
          El hecho de que la usuaria participe en la dinámica implica el
          conocimiento y la aceptación de las condiciones establecidas en
          reglamento, página web y correo electrónico.
        </>,
        <>
          La actividad estará al aire desde el 18 de agosto del 2021 hasta
          agotar existencias.
        </>,
        <>
          La persona que se encuentre en la dirección en el momento de la
          entrega podrá recibir el Kit, firmando una constancia de recepción.
          Así se considerará el kit como entregado y la firma será considerada
          como prueba de la entrega.
        </>,
        <>El stock de Kits Nosotras es limitado.</>,
        <>
          Solo se realizará un intento de envío del Kit, en caso que la
          dirección esté incorrecta, no se enviará de nuevo.
        </>,
        <>
          Solo se permitirá el envío de máximo dos Kits por dirección siempre y
          cuando sean personas diferentes. Cada usuaria puede participar solo
          una vez.
        </>,
        <>Actividad válida solo para usuarias de Perú.</>,
        <>
          En caso de tener dudas, o si quieres recibir mayor información,
          comunícate con la línea de servicio y atención al cliente en Perú:
          0800 7 1218
        </>,
      ]
    case 'es-CL':
      return [
        <>
          Todas las participantes de esta actividad deben estar registradas en
          NosotrasOnline.cl
        </>,
        <>
          Al aceptar los términos y condiciones de la actividad las usuarias
          aceptan el manejo de sus datos por parte de la marca Nosotras.
        </>,
        <>
          Ganarán las usuarias que hayan realizado los tres pasos: 1.
          Registrarse o actualizar sus datos. 2. Ver el video educativo 3.
          Resuelvan la trivia y además hayan ingresado datos verídicos, los
          mismos que serán validados al momento de la entrega.
        </>,
        <>
          Sólo participarán por Kits Nosotras usuarias cuyas edades se
          comprendan entre los 9 a 18 años de edad. Dicho rango de edad
          corresponde a los grados con los cuales la marca trabaja el Programa
          Colegios.
        </>,
        <>
          Todas las imágenes de los premios que están en el sitio, son
          referenciales.
        </>,
        <>
          En caso de que la usuaria no pueda recibir el premio, no tendrá
          derecho a ningún otro producto diferente ni a ningún tipo de
          indemnización o compensación.
        </>,
        <>
          Los premios no son acumulables con otras promociones o actividades, no
          son intercambiables por dinero ni son canjeables por ningún otro
          concepto o producto identificado con la marca Nosotras ® o de Grupo
          Familia S. A.
        </>,
        <>
          La marca Nosotras tiene el derecho de anular o descalificar cualquier
          material que considere que no cumple con las reglas de la actividad.
          Así mismo, procederá con el material que no tenga relación con la
          mecánica de la actividad, que considere no apto o que atente contra
          los valores de la marca.
        </>,
        <>
          Con el hecho de participar en la actividad, las usuarias aceptan y
          autorizan que su nombre y sus imágenes aparezcan en las publicaciones
          y demás material de divulgación con fines promocionales que los
          organizadores deseen hacer durante el concurso o una vez este
          finalice, sin que ello implique la obligación de remunerarlas o
          compensarlas.
        </>,
        <>
          El hecho de que la usuaria participe en la dinámica implica el
          conocimiento y la aceptación de las condiciones establecidas en
          reglamento, página web y correo electrónico.
        </>,
        <>
          La actividad estará al aire desde el 11 de octubre del 2021 hasta
          agotar stock del Kit Nosotras.
        </>,
        <>
          Una vez finalizada la actividad, la marca se pondrá en contacto con
          las usuarias ganadoras del Kit Nosotras para informarles sobre la
          dinámica de entrega y para validar los datos correspondientes.
          Asimismo, se coordinará las fechas de entrega.
        </>,
        <>El stock de Kits Nosotras es limitado.</>,
        <>
          Al momento de entregar el Kit Nosotras, la usuaria o quién reciba
          dicho Kit deberá firmar una constancia de recepción.
        </>,
        <>Actividad válida solo para usuarias de Chile.</>,
        <>
          En caso de tener dudas, o si quieres recibir mayor información,
          comunícate con la línea de servicio y atención al cliente en Chile:
          800262606
        </>,
      ]
    case 'es-DO':
      return [
        <>
          Todas las participantes de esta actividad deben estar registradas en
          Nosotrasonline.com.do
        </>,
        <>
          Al aceptar los términos y condiciones de la actividad las usuarias
          aceptan el manejo de sus datos por parte de la marca Nosotras.
        </>,
        <>
          Ganarán las usuarias que hayan realizado los tres pasos: 1.
          Registrarse o actualizar sus datos. 2. Ver el video educativo 3.
          Resuelvan la trivia y además hayan ingresado datos verídicos, los
          mismos que serán validados al momento de la entrega.
        </>,
        <>
          Sólo participarán por Kits Nosotras usuarias cuyas edades se
          comprendan entre los 9 a 18 años de edad. Dicho rango de edad
          corresponde a los grados con los cuales la marca trabaja el Programa
          Colegios.
        </>,
        <>
          Todas las imágenes de los premios que están en el sitio, son
          referenciales.
        </>,
        <>
          En caso de que la usuaria no pueda recibir el premio, no tendrá
          derecho a ningún otro producto diferente ni a ningún tipo de
          indemnización o compensación.
        </>,
        <>
          Los premios no son acumulables con otras promociones o actividades, no
          son intercambiables por dinero ni son canjeables por ningún otro
          concepto o producto identificado con la marca Nosotras ® o de Grupo
          Familia S. A.
        </>,
        <>
          La marca Nosotras tiene el derecho de anular o descalificar cualquier
          material que considere que no cumple con las reglas de la actividad.
          Así mismo, procederá con el material que no tenga relación con la
          mecánica de la actividad, que considere no apto o que atente contra
          los valores de la marca.
        </>,
        <>
          Con el hecho de participar en la actividad, las usuarias aceptan y
          autorizan que su nombre y sus imágenes aparezcan en las publicaciones
          y demás material de divulgación con fines promocionales que los
          organizadores deseen hacer durante el concurso o una vez este
          finalice, sin que ello implique la obligación de remunerarlas o
          compensarlas.
        </>,
        <>
          El hecho de que la usuaria participe en la dinámica implica el
          conocimiento y la aceptación de las condiciones establecidas en
          reglamento, página web y correo electrónico.
        </>,
        <>
          La actividad estará al aire desde el XX de XXXX hasta agotar stock del
          Kit Nosotras.
        </>,
        <>
          Una vez finalizada la actividad, la marca se pondrá en contacto con
          las usuarias ganadoras del Kit Nosotras para informarles sobre la
          dinámica de entrega y para validar los datos correspondientes.
          Asimismo, se coordinará las fechas de entrega.
        </>,
        <>El stock de Kits Nosotras es limitado.</>,
        <>
          Al momento de entregar el Kit Nosotras, la usuaria o quién reciba
          dicho Kit deberá firmar una constancia de recepción.
        </>,
        <>Actividad válida solo para usuarias de República Dominicana.</>,
        <>
          En caso de tener dudas, o si quieres recibir mayor información,
          comunícate con la línea de servicio y atención al cliente en República
          Dominicana: 829 9479621
        </>,
      ]
    case 'es-EC':
      return [
        <>
          Todas las participantes de esta actividad deben estar registradas en
          Nosotrasonline.com.ec
        </>,
        <>
          Al aceptar los términos y condiciones de la actividad las usuarias
          aceptan el manejo de sus datos por parte de la marca Nosotras.
        </>,
        <>
          Ganarán las usuarias que hayan realizado los tres pasos: 1.
          Registrarse o actualizar sus datos. 2. Ver el video educativo 3.
          Resuelvan la trivia y además hayan ingresado datos verídicos, los
          mismos que serán validados al momento de la entrega.
        </>,
        <>
          Sólo participarán por Kits Nosotras usuarias cuyas edades se
          comprendan entre los 9 a 18 años de edad. Dicho rango de edad
          corresponde a los grados con los cuales la marca trabaja el Programa
          Colegios.
        </>,
        <>
          Todas las imágenes de los premios que están en el sitio, son
          referenciales.
        </>,
        <>
          En caso de que la usuaria no pueda recibir el premio, no tendrá
          derecho a ningún otro producto diferente ni a ningún tipo de
          indemnización o compensación.
        </>,
        <>
          Los premios no son acumulables con otras promociones o actividades, no
          son intercambiables por dinero ni son canjeables por ningún otro
          concepto o producto identificado con la marca Nosotras ® o de Grupo
          Familia S. A.
        </>,
        <>
          La marca Nosotras tiene el derecho de anular o descalificar cualquier
          material que considere que no cumple con las reglas de la actividad.
          Así mismo, procederá con el material que no tenga relación con la
          mecánica de la actividad, que considere no apto o que atente contra
          los valores de la marca.
        </>,
        <>
          Con el hecho de participar en la actividad, las usuarias aceptan y
          autorizan que su nombre y sus imágenes aparezcan en las publicaciones
          y demás material de divulgación con fines promocionales que los
          organizadores deseen hacer durante el concurso o una vez este
          finalice, sin que ello implique la obligación de remunerarlas o
          compensarlas.
        </>,
        <>
          El hecho de que la usuaria participe en la dinámica implica el
          conocimiento y la aceptación de las condiciones establecidas en
          reglamento, página web y correo electrónico.
        </>,
        <>
          La actividad estará al aire desde el XX de XXXX hasta agotar stock del
          Kit Nosotras.
        </>,
        <>
          Una vez finalizada la actividad, la marca se pondrá en contacto con
          las usuarias ganadoras del Kit Nosotras para informarles sobre la
          dinámica de entrega y para validar los datos correspondientes.
          Asimismo, se coordinará las fechas de entrega.
        </>,
        <>El stock de Kits Nosotras es limitado.</>,
        <>
          Al momento de entregar el Kit Nosotras, la usuaria o quién reciba
          dicho Kit deberá firmar una constancia de recepción.
        </>,
        <>Actividad válida solo para usuarias de Ecuador</>,
        <>
          En caso de tener dudas, o si quieres recibir mayor información,
          comunícate con la línea de servicio y atención al cliente en Ecuador:
          1800 203040
        </>,
      ]
    default:
      return [<>ESTA ACTIVIDAD NO ESTA DISPONIBLE AUN EN TU PAIS</>]
  }
}
